import styled from 'styled-components';
import color from '../../configs/color';
import boxShadow from '../../configs/boxShadow';

const HeroWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 46px;
  justify-content: space-between;
  align-items: center;
  padding: 46px 32px;
  border-radius: 12px;
  background-image: ${(props) => {
    return `url(${props.bgImage})`;
  }};
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 24px;
  .container_setting_license_hero_info {
    color: ${color.black1};
    .component_info_license_date {
      margin-top: 12px;
      position: relative;
      .component_info_license_date_btn {
        background: ${color.grey5};
        display: flex;
        align-items: center;
        column-gap: 10px;
        padding: 0 12px;
        height: 36px;
        border-radius: 12px;
        width: max-content;
        cursor: pointer;
        font-weight: 600;
        color: ${color.black2};
        .font-paragraph_medium {
          margin-top: 4px;
        }
        .anticon {
          font-size: 20px;
        }
        :hover,
        :focus,
        :active {
          background-color: ${color.grey3};
          border-color: ${color.grey3};
        }
      }
      .component_info_license_date_action_box {
        position: absolute;
        top: 40px;
        background: ${color.grey5};
        padding: 12px 20px;
        border: 1px solid ${color.grey2};
        box-shadow: ${boxShadow.normal};
        border-radius: 12px;
        z-index: 10;
        width: 374px;
        .component_action_box_header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          height: 42px;
          > div:first-child {
            color: black;
          }
          .component_close {
            cursor: pointer;
            .anticon {
              font-size: 20px;
              color: #000000a6;
            }
          }
        }
        .component_action_box_body {
          > div:first-child {
            border-bottom: 1px solid ${color.grey2};
          }
          .component_action_box_body_item {
            padding: 12px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            > div:first-child {
              color: ${color.black4};
            }
          }
        }
      }
    }
  }
  .container_setting_license_hero_card {
    min-width: 552px;
  }
`;

export default HeroWrapper;
